import { motion } from "framer-motion";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Arjun Kapoor",
    text: "Absolutely thrilling! The go-kart track at Big Bang Speedway is the best I've experienced in Uttarakhand. Speeds up to 55 km/h on those long straights — pure adrenaline!",
    rating: 5,
  },
  {
    name: "Priya Sharma",
    text: "Took the entire family here and everyone had a blast. The kids loved the play zone, my husband couldn't get enough of the go-karts, and I enjoyed the café. Friendly staff!",
    rating: 5,
  },
  {
    name: "Rahul Negi",
    text: "4.8 stars is well deserved! The track design is genuinely F1-inspired with technical turns that really test your driving skills. Must-visit in Dehradun.",
    rating: 5,
  },
  {
    name: "Sneha Rawat",
    text: "Finally, Dehradun has a world-class entertainment venue! The arcade zone is packed with great games, and the go-karting track is unmatched.",
    rating: 5,
  },
  {
    name: "Vikram Singh",
    text: "Visited with my college friends and we had the time of our lives. The group package is amazing value. Already planning our next visit!",
    rating: 5,
  },
  {
    name: "Meera Joshi",
    text: "The paintball arena is so much fun! And the café serves great snacks. Perfect weekend destination for groups and families alike.",
    rating: 5,
  },
];

function TestimonialCard({ t, index }) {
  return (
    <div
      data-testid={`testimonial-card-${index}`}
      className="flex-shrink-0 w-[340px] sm:w-[400px] mx-4 p-6 bg-[#141414] border border-white/10 hover:border-[#e8001d]/30 transition-colors duration-300"
    >
      <div className="flex gap-1 mb-4">
        {Array.from({ length: t.rating }).map((_, si) => (
          <Star key={si} size={14} className="text-[#e8001d] fill-[#e8001d]" />
        ))}
      </div>
      <p className="text-[#a3a3a3] text-sm leading-relaxed mb-6 italic">
        &ldquo;{t.text}&rdquo;
      </p>
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-[#e8001d]/20 flex items-center justify-center font-heading text-[#e8001d] text-lg">
          {t.name.charAt(0)}
        </div>
        <div>
          <div className="text-[#f5f5f5] text-sm font-semibold">{t.name}</div>
          <div className="text-[#a3a3a3] text-xs">Verified Racer</div>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  // Duplicate for seamless infinite scroll
  const allTestimonials = [...TESTIMONIALS, ...TESTIMONIALS];

  return (
    <section data-testid="testimonials-section" className="py-24 sm:py-32 bg-[#0a0a0a] overflow-hidden relative">
      <div className="absolute inset-0 checkered-bg opacity-10" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10 mb-12">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#e8001d] font-bold mb-4 block">
            What Racers Say
          </span>
          <h2 className="font-heading text-[#f5f5f5] text-5xl sm:text-7xl uppercase leading-none mb-4">
            Testimonials
          </h2>
          <p className="text-[#a3a3a3] text-base">
            Rated 4.8&#9733; from 842+ reviews on JustDial
          </p>
        </motion.div>
      </div>

      {/* Infinite auto-spinning marquee */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-[#0a0a0a] to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-[#0a0a0a] to-transparent pointer-events-none" />

        <div className="flex testimonial-marquee" style={{ width: "fit-content" }}>
          {allTestimonials.map((t, i) => (
            <TestimonialCard key={i} t={t} index={i % TESTIMONIALS.length} />
          ))}
        </div>
      </div>
    </section>
  );
}
